module.exports = __webpack_public_path__ + "static/media/01_thumbnail.737c6be2.jpg";